import type { CodingContext } from '@imprivata-cloud/dataprivacy';
import { useMutation } from '@tanstack/react-query';
import { StorageKeys } from '../../api/constants';
import { addImprIdpDirectory } from '../../api/setupServices';
import type { DirectoryAddRequest } from '../../api/types';
import { useErrorContext } from '../../errorHandler/context/ErrorContext';
import type { AppError } from '../../errorHandler/errors';
import { STEPS } from '../constants';
import { useNavigateToNextStep } from './useNavigateToNextStep';

export type AddDirectory = {
  addDirectoryRequest: DirectoryAddRequest;
  codingContext: CodingContext;
};

const useAddImprIdpDirectory = () => {
  const navigateToNextStep = useNavigateToNextStep();
  const { emitError } = useErrorContext();

  return useMutation({
    mutationFn: async (request: AddDirectory) => {
      return addImprIdpDirectory(request.addDirectoryRequest, request.codingContext);
    },
    onSuccess: () => {
      console.log('Imprivata IdP Directory added successfully:');
      sessionStorage.setItem(StorageKeys.IMPR_IDP_USED, 'true');
      navigateToNextStep(STEPS.EXTERNAL_IDP_INFO);
    },
    onError: (error) => {
      emitError(error as AppError);
      console.log('Error saving Imprivata IDP Directory/Initial User', error);
    },
  });
};

export { useAddImprIdpDirectory };
